import {
  ORG_MEMBERS_QUERY_KEY,
  ORG_PROJECTS_QUERY_KEY,
  ORGANIZATIONS_QUERY_KEY,
  PROJECTS_QUERY_KEY,
} from "@frontend-shared/constants";

import { schedulePushRefetch } from "@/lib/push-refetch-scheduler";

// NOTE: Every cache an organization ownership change invalidates (NSAI-3616).
// `isOwner` lives on the organizations query, but a transfer also re-grants
// project-admin on every project in the org, which moves the `permissions`
// flags the owner-gated tabs fall back to — so the project and member lists go
// stale at the same moment. Keys are matched by prefix, so the uuid-suffixed
// variants (`[ORG_MEMBERS_QUERY_KEY, uuid]`) are covered too. Shared by the WS
// push handler and the socket-reconnect catch-up so the two can never drift
// apart. NSAI-5911 — marked stale at once, refetched once the tab is visible
// (a hidden tab cannot act on an owner affordance anyway).
export const ORGANIZATION_ACCESS_QUERY_KEYS = [
  [ORGANIZATIONS_QUERY_KEY],
  [ORG_MEMBERS_QUERY_KEY],
  [ORG_PROJECTS_QUERY_KEY],
  [PROJECTS_QUERY_KEY],
] as const;

export const scheduleOrganizationAccessRefetch = (): void => {
  schedulePushRefetch(ORGANIZATION_ACCESS_QUERY_KEYS);
};
